// Footer for marketing pages (own-chrome routes: /preview, /try). Matches
// the top nav's wordmark + max-w-7xl container so the whole page reads as
// one column of chrome. Kept minimal: wordmark + tagline left, link groups
// right, small copyright bar at the bottom.

import { Link } from 'react-router'

const YEAR = new Date().getFullYear()

type FooterLink = { label: string; href: string; external?: boolean }
type FooterGroup = { title: string; links: FooterLink[] }

const GROUPS: FooterGroup[] = [
	{
		title: 'Legal',
		links: [
			{ label: 'Terms', href: '/terms' },
			{ label: 'Privacy', href: '/privacy' },
			{ label: 'Security', href: '/security' },
		],
	},
	{
		title: 'Contact',
		links: [
			{ label: 'X · @underemployed', href: 'https://x.com/underemployed', external: true },
		],
	},
]

export function SiteFooter() {
	return (
		<footer className="border-border/60 mt-12 border-t">
			{/* px-6 matches every _site+ page's outer padding so footer
			    content aligns with page content at all viewports. */}
			<div className="mx-auto max-w-7xl px-6 py-10">
				<div className="grid grid-cols-1 gap-8 md:grid-cols-[2fr_1fr_1fr]">
					<div className="max-w-sm">
						<Link to="/" className="text-base font-semibold tracking-tight">
							LedgerAI
						</Link>
						<p className="text-muted-foreground mt-2 text-sm">
							The statements other software gave up on.
						</p>
					</div>
					{GROUPS.map((g) => (
						<div key={g.title}>
							<h3 className="text-xs font-semibold uppercase tracking-widest">
								{g.title}
							</h3>
							<ul className="mt-3 space-y-2">
								{g.links.map((l) => (
									<li key={l.href}>
										{l.external ? (
											<a
												href={l.href}
												rel="noopener noreferrer"
												target={l.href.startsWith('mailto:') ? undefined : '_blank'}
												className="text-muted-foreground hover:text-foreground text-sm"
											>
												{l.label}
											</a>
										) : (
											<Link
												to={l.href}
												className="text-muted-foreground hover:text-foreground text-sm"
											>
												{l.label}
											</Link>
										)}
									</li>
								))}
							</ul>
						</div>
					))}
				</div>
				<div className="border-border/60 text-muted-foreground mt-8 flex flex-col justify-between gap-2 border-t pt-6 text-xs sm:flex-row">
					<span>© {YEAR}</span>
				</div>
			</div>
		</footer>
	)
}
